import { render, staticRenderFns } from "./DPhoneInput.vue?vue&type=template&id=f4c5d12a"
import script from "./DPhoneInput.vue?vue&type=script&lang=js"
export * from "./DPhoneInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports